// extracted by mini-css-extract-plugin
export default {"formContainer":"LoginPage_formContainer__NpVqf","title":"LoginPage_title__uhZXj","text":"LoginPage_text__d2odV","changeNumberLink":"LoginPage_changeNumberLink__HhuLb"};